import { contract } from '@aviv_price-pages/brand';
import { appendEphemeralParam } from '@/helpers/ephemeral/ephemeral';
export function redirect(req, res) {
    const { pathname, search } = req.url;
    const pathPrefix = contract.basePath;
    if (!contract.redirects)
        return;
    contract.redirects.forEach((redirect) => {
        if (pathname === `${pathPrefix}${redirect.source}`) {
            const destinationPath = `${pathPrefix}${redirect.destination}`;
            const fullUrl = appendEphemeralParam(destinationPath + search);
            return res.redirect(fullUrl, 301);
        }
    });
}
